/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Empty_TitleInputs */

const en_directory_platforms_empty_title = /** @type {(inputs: Directory_Platforms_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform data is still growing`)
};

const zh_directory_platforms_empty_title = /** @type {(inputs: Directory_Platforms_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台数据仍在增长`)
};

/**
* | output |
* | --- |
* | "Platform data is still growing" |
*
* @param {Directory_Platforms_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_empty_title = /** @type {((inputs?: Directory_Platforms_Empty_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Empty_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_empty_title(inputs)
	return zh_directory_platforms_empty_title(inputs)
});
export { directory_platforms_empty_title as "directory.platforms.empty_title" }